import { Text } from '@mantine/core';
import { formatCascade, type PayoutGroup } from '~/entities/payout';
import { type TableCell, type TableData, type TableRow } from '~/shared/ui/Table';

const prepareHeaders: TableCell[] = [
    { key: 'id', content: 'ID', ta: 'center' },
    { key: 'name', content: 'Название', ta: 'center' },
    { key: 'traders', content: 'Трейдеры', ta: 'center' },
    { key: 'capacity', content: 'Вместимость', ta: 'center' },
    { key: 'overflowCapacity', content: 'Доп. вместимость', ta: 'center' },
];

type PrepareTableDataProps = {
    groups?: PayoutGroup[];
};

const prepareRows = ({ groups }: PrepareTableDataProps): TableRow<PayoutGroup>[] => {
    if (!groups) {
        return [];
    }

    return groups.map((group) => ({
        key: group.id?.value ?? 0,
        cells: [
            { key: 'id', content: <Text ta='center'>{group.id?.value}</Text> },
            { key: 'name', content: <Text ta='center'>{group.name?.value}</Text> },
            { key: 'traders', content: <Text ta='center'>{formatCascade.traderNames(group.traders)}</Text> },
            { key: 'capacity', content: <Text ta='center'>{group.queue?.capacity ?? '—'}</Text> },
            { key: 'overflowCapacity', content: <Text ta='center'>{group.queue?.overflowCapacity ?? '—'}</Text> },
        ],
        item: group,
    }));
};

export const createTableData = ({ groups }: PrepareTableDataProps): TableData<PayoutGroup> => {
    return {
        head: prepareHeaders,
        rows: prepareRows({ groups }),
        caption: groups?.length === 0 ? 'Групп нет' : undefined,
    };
};
